export default __webpack_public_path__ + "static/media/sphere-normal.ceaba7ec.png";